/**
 * /app/$tenantSlug/settings/checklists — opens the first stage tab
 * (Pre-boarding).
 */

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/settings/checklists/",
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/app/$tenantSlug/settings/checklists/preboarding",
      params: { tenantSlug: params.tenantSlug },
      replace: true,
    });
  },
});
